import AccountTerminationForm from '@/components/ModalRenderer/components/components/AccountTerminationForm/AccountTerminationForm';
import { Modal } from '@/components/ModalRenderer/Modal';

type Props = {
  title: string;
  buttonText: string;
  children: React.ReactNode;
};

const AccountTerminationModalBase = ({ title, buttonText, children }: Props) => (
  <Modal title={title}>
    <div className="flex flex-col gap-4">
      {children}
      <AccountTerminationForm buttonText={buttonText} />
    </div>
  </Modal>
);

export default AccountTerminationModalBase;
